<template>
  <div class="container" :class="{'phonePadding':deviceType==2}">
    <!-- pc导航栏 -->
    <div class="navigationBar" v-if="deviceType==1">
      <div class="navigationBar--logo">
        <img src="@/assets/imgs/logo.png" alt class="logoImg" />
      </div>
      <div class="navigationBar--list">
        <li
          class="navigationBar--list__li"
          v-for="(item,i) in menuData"
          :key="i"
          @click.stop="menuClick(item.top.menu_id)"
        >
        {{item.top.menu_name}}
          <ul class="secondNav" v-if="item.bottom">
            <li class="secondNav--li" v-for="(nav,i) in item.bottom" :key="i" @click.stop="toDetails(nav.menu_id)">
              {{nav.menu_name}}
            </li>
          </ul>
        </li>
      </div>
    </div>

    <!-- 移动端导航栏 -->
    <div class="phoneBar" v-if="deviceType==2">
      <div class="phoneBarwrap">
        <div class="phoneBar--logo">
          <img src="@/assets/imgs/logo.png" alt />
        </div>
        <div class="phoneBar--btn" @click="isShowSide = !isShowSide">
          <img src="@/assets/imgs/menu.png" alt class="phoneBar--btn__choose" v-if="!isShowSide" />
          <!-- 关闭按钮 -->
          <img src="@/assets/imgs/close_btn.png" alt class="phoneBar--btn__closeBtn" v-else />
        </div>
      </div>
    </div>

    <!-- 侧边栏 -->
    <transition name="popUp">
      <div class="sideBar" v-if="deviceType==2&&isShowSide">
        <!-- 遮罩层 -->
        <div class="sideBar--mask" @click="isShowSide = !isShowSide"  @touchmove.prevent></div>
        <!-- 内容 -->
        <div class="sideBar--leftSide">
          <div class="sideBar--leftSide__close" @click="isShowSide = !isShowSide">
            <img src="@/assets/imgs/close_btn.png" alt />
          </div>
          <ul class="sideBar--leftSide__ul">
            <li
              class="sideBar--leftSide__ul_li"
              :class="[{'active':item.top.menu_id==menuIndex&&showSecond}]"
              v-for="(item,i) in menuData"
              :key="i"
              @click.stop="onPageTo(item.top.menu_id)"
            >
            {{item.top.menu_name}}
            <!-- 箭头 -->
            <img 
              :src="item.top.menu_id==menuIndex&&item.top.menu_id==showSecond?require('../assets/imgs/arrow_down.png'):require('../assets/imgs/arrow_right.png')"
              class="arr_right"
              :class="{'arr_down':item.top.menu_id==menuIndex&&item.top.menu_id==showSecond}"
              @click.stop="onPopSec(item.top.menu_id)"/>
              <ul class="sideBar--secondNav" v-if="item.top.menu_id==menuIndex&&item.top.menu_id==showSecond">
                <li
                  class="sideBar--secondNav__li"
                  v-for="(item,i) in item.bottom"
                  :key="i"
                  @click.stop="toDetails(item.menu_id)"
                >
                {{item.menu_name}}
                </li>
              </ul>
            </li>
          </ul>
        </div>
        <!-- 分享区域 -->
        <div class="sideBar--sharebtn">
          <sharebtn></sharebtn>
        </div>
        <!-- 底部qq分享 -->
        <div class="sideBar--qqShare">
          <qq></qq>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import qq from "./qq";
import sharebtn from "./shareBtn";
export default {
  name: "Header",
  data() {
    return {
      // 控制侧边栏
      isShowSide: false,
      // 箭头样式
      menuIndex: 1,
      showSecond: null,
      // 设备类型
      deviceType: 1,
      menuData:[],    //手机端导航栏
      arrShow:true,   //箭头
    };
  },
  components: {
    sharebtn,
    qq
  },
  methods: {
      // 1代表PC，2代表移动端
    resetScr() {
      var that =this
      window.onresize = () => {
        return (() => {
          let screenWid = document.body.clientWidth
          that.deviceType = screenWid<1025?2:1
          // console.log(that.deviceType)
          sessionStorage.setItem('resizeScreen',that.deviceType)
        })();
      };
    },
    // 判断设备类型
    checkDevice(){
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      this.deviceType = flag ? 2 : 1;

    },
    // 导航栏跳转(PC)
    menuClick(menu_id) {
      if(menu_id==1){
        this.$router.push({name: "HomePage"})
      }
      else if(menu_id==2){
        this.$router.push('/aboutUs')
      }
      else if(menu_id==33){
        // console.log(1111)
        this.$router.push('/examples')
      }
       else if(menu_id==3){
        this.$router.push('/serveProducts')
      }
      else if(menu_id==4){
        this.$router.push('/latestNews')
      }
      else if(menu_id==5){
        this.$router.push('/contactUs')
      }
    },

    // 二级栏目跳转到详细（PC）
    toDetails(menu_id){
      // console.log(menu_id)
      this.$router.push({
        path:'/MenuDetails',
        query: {
          id: menu_id
        }
      })
      // 关闭弹窗
      setTimeout(() => {
        this.isShowSide = !this.isShowSide
      }, 200);
    },
    // 点击导航栏(移动端)
    onPageTo(menu_id) {
      
      this.menuIndex = menu_id;
      // console.log(menu_id)
      if (this.showSecond !== menu_id) {
        this.showSecond = menu_id;
      } else {
        this.showSecond = 1;
      }
       this.menuClick(menu_id)       //页面跳转
      setTimeout(() => {
        this.isShowSide = !this.isShowSide
      }, 200);
    },

    // 请求菜单栏数据
    getMenuData(){
      this.$post("api/index/index/header").then(res=>{
        // console.log(res.data)
        if(res.code==1){
          this.menuData=res.data.menu;
        }
        else{
          alert(res.msg)
        }
      }).catch((err) => {
          alert(err)
      })
    },
     // 箭头
    onPopSec(menu_id){
      // console.log(menu_id)
      this.menuIndex = menu_id;
      if (this.showSecond !== menu_id) {
        this.showSecond = menu_id;
      } else {
        this.showSecond = 1;
      }
      // this.arrShow = !this.arrShow
    },
  },
 
  created() {
    // 设备类型
    this.checkDevice()
    // 监听屏幕大小
    let clientWid = document.body.clientWidth 
    if (clientWid<1024) {
      sessionStorage.setItem('resizeScreen',2)
    }
    else{
      sessionStorage.setItem('resizeScreen',1)
    }  
    this.deviceType = sessionStorage.getItem('resizeScreen')

    // 菜单栏数据
    this.getMenuData()
    

  },
  mounted() {
    this.resetScr()
  },
};
</script>

<style lang="less">
.container {
  font-size: calc(100vw / 19.2)!important;
  width: 100%;
  position: relative;
  // PC导航栏
  .navigationBar {
    width: 85%;
    margin: 0 auto;
    padding-bottom: 1%;
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    .navigationBar--logo {
      width: 1.6em;
      height: 1.2em;
      margin-top: -1%;
      .logoImg {
        width: 100%;
        height: 100%;
      }
    }
    .navigationBar--list {
      display: flex;
      .navigationBar--list__li {
        padding: 0 1.15em;
        list-style-type: none;
        font-size: .2em;
        color: #777777;
        // font-weight: bold;
        position: relative;
        cursor: pointer;
        &::after {
          content: "";
          height: 1em;
          width: 1px;
          background: #777777;
          position: absolute;
          right: 0;
          top: 4px;
        }
        &:last-child {
          &::after {
            height: 0;
            width: 0;
          }
        }
        .secondNav {
          display: none;
          position: absolute;
          left: 23%;
          z-index: 1000;
          .secondNav--li {
            background-color: #dcdcdd;
            padding: 0.5em 0.8em;
            font-size: .65em;
            margin-bottom: .25em;
            cursor: pointer;
          }
        }
      }
      .navigationBar--list__li:hover {
        .secondNav {
          display: block;
        }
      }
    }
  }
  // 移动端导航栏
  .phoneBar {
    width: 100%;
    background-color: #5f5d5d;
    padding-top: 0.4rem;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 999;
    .phoneBarwrap {
      width: 100%;
      height: auto;
      background-color: #ffffff;
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 1% 3%;
      box-sizing: border-box;
      .phoneBar--logo {
        width: 16%;
        height: auto;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .phoneBar--btn {
        .phoneBar--btn__choose {
          width: 0.6rem;
          height: auto;
        }
        .phoneBar--btn__closeBtn {
          width: 0.30rem;
          height: 0.30rem;
        }
      }
    }
  }
  // 左侧栏动画效果
  .popUp-enter {
    transform: translateX(-0.75rem);
  }
  .popUp-enter-active {
    transition: transform 0.5s;
  }
  .popUp-leave-to {
    transform: translateX(0rem);
  }
  .sideBar {
    z-index: 1000;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 0.75rem;

    .sideBar--mask {
      background: #000000;
      opacity: 0.5;
      width: 100vw;
      height: 100vh;
    }
    .sideBar--leftSide {
      width: 5rem;
      height: 100vh;
      background: #ffffff;
      position: fixed;
      top: 0.4rem;
      left: 0;
      display: flex;
      flex-direction: column;

      .sideBar--leftSide__close {
        width: 0.30rem;
        height: 0.30rem;
        align-self: flex-end;
        margin: 0.33rem;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .sideBar--leftSide__ul {
        display: flex;
        flex-direction: column;
        .sideBar--leftSide__ul_li {
          color: #777777;
          padding: 0.24rem 0.4rem;
          border-bottom: 2px solid #000000;
          font-size: 0.2rem;
          // font-weight: bold;
          position: relative;
          &:first-child {
            background: none;
          }
          .sideBar--secondNav {
            text-indent: 0.2rem;
            font-size: 0.18rem;
            line-height: 0.5rem;
            font-weight: normal;
            color: #777777;
            li {
              &:first-child {
                margin-top: 0.2rem;
              }
            }
          }
          // 箭头样式
          .arr_right{
            width: .29rem;
            height: .53rem;
            position: absolute;
            right: .33rem;
            top: .17rem;

          }
          .arr_down{
             width: .53rem;
            height: .29rem;
            position: absolute;
            right: .25rem;
            top: .24rem;
          }
        }
        // 向下箭头样式（有二级导航）
        .activeClass {
          color: #8fa924;
          font-weight: normal;
        }
        // 向下箭头样式（没有二级导航）
        .active {
          color: #8fa924;
          font-weight: normal;
        }
      }
    }
    // 分享
    .sideBar--sharebtn {
      position: absolute;
      top: 3.5rem;
      right: -6.6rem;
    }

    // 底部qq分享
    .sideBar--qqShare {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      height: 0.99rem;
      background: #ffffff;
    }
  }
}
// 移动端轮播图距离顶部的距离
.phonePadding {
  padding-top: 1.28rem;
}

// ipad侧边栏
@media screen and (min-width: 751px) and (max-width: 1024px) {
  .sideBar--leftSide {
    width: 3.72rem !important;
    .sideBar--leftSide__close {
      width: 0.3rem !important;
      height: 0.3rem !important;
    }
  }
}

@media screen and (min-width: 1024px) and (max-width: 1400px){
  .secondNav{
    left: 18% !important;
    .secondNav--li{
      padding:0.3em .4em !important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/header.vue